import { render, staticRenderFns } from "./delete-bucket.html?vue&type=template&id=7b6a2010&scoped=true&external"
import script from "./delete-bucket.js?vue&type=script&lang=js&external"
export * from "./delete-bucket.js?vue&type=script&lang=js&external"
import style0 from "./delete-bucket.scss?vue&type=style&index=0&id=7b6a2010&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6a2010",
  null
  
)

export default component.exports